export const topBarHeight = 150
export const sideNavWidth = 260
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200
export const dataGridRowHeight = 30
export const dataGridHeight = 700
// typography.js
// export const Fonts = {
//   // Poppins
//   regular: "Poppins-Regular",
//   medium: "Poppins-Medium",
//   semiBold: "Poppins-SemiBold",
//   bold: "Poppins-Bold",
//   extraBold: "Poppins-ExtraBold",
//   black: "Poppins-Black",

//   // Inter
//   interRegular: "Inter-Regular",
//   interMedium: "Inter-Medium",
//   interSemiBold: "Inter-SemiBold",
//   interBold: "Inter-Bold",
//   interExtraBold: "Inter-ExtraBold",
//   interBlack: "Inter-Black",

//   // Manrope
//   manropeRegular: "Manrope-Regular",
//   manropeMedium: "Manrope-Medium",
//   manropeSemiBold: "Manrope-SemiBold",
//   manropeBold: "Manrope-Bold",
//   manropeExtraBold: "Manrope-ExtraBold",
//   manropeBlack: "Manrope-Black",
// };
export const Fonts = {
  regular: "Poppins",
  medium: "Poppins",
  semiBold: "Poppins",
  bold: "Poppins",
  extraBold: "Poppins",
  black: "Poppins",

  interRegular: "Inter",
  interMedium: "Inter",
  interSemiBold: "Inter",
  interBold: "Inter",
  interExtraBold: "Inter",
  interBlack: "Inter",

  manropeRegular: "Manrope",
  manropeMedium: "Manrope",
  manropeSemiBold: "Manrope",
  manropeBold: "Manrope",
  manropeExtraBold: "Manrope",
  manropeBlack: "Manrope",
};

// ---------------- Typography ----------------
export const typography = {
  h1: { fontFamily: Fonts.interBold, fontSize: "32px", lineHeight: "40px", letterSpacing: "-0.16px" },
  h2: { fontFamily: Fonts.manropeBold, fontSize: "28px", lineHeight: "35px", letterSpacing: "-0.07px" },
  h3: { fontFamily: Fonts.semiBold, fontSize: "24px", lineHeight: "32px" },
  h4Bold: { fontFamily: Fonts.semiBold, fontSize: "20px", lineHeight: "28px" },
  h4: { fontFamily: Fonts.medium, fontSize: "20px", lineHeight: "28px" },
  h5: { fontFamily: Fonts.medium, fontSize: "18px", lineHeight: "24px" },
  h6Bold: { fontFamily: Fonts.semiBold, fontSize: "16px", lineHeight: "22px" },
  h6: { fontFamily: Fonts.medium, fontSize: "16px", lineHeight: "22px" },
h2bold: { fontFamily: Fonts.manropeBold, fontSize: "28px", lineHeight: "26px", letterSpacing: "-0.25px" },

  bodyLarge: { fontFamily: Fonts.interRegular, fontSize: "16px", lineHeight: "24px" },
  bodyMedium: { fontFamily: Fonts.interRegular, fontSize: "14px", lineHeight: "22px" },
  bodySmall: { fontFamily: Fonts.interRegular, fontSize: "12px", lineHeight: "18px", letterSpacing: "0.03px" },

  captionBold: { fontFamily: Fonts.interSemiBold, fontSize: "12px", lineHeight: "18px" },
  overline: { fontFamily: Fonts.interRegular, fontSize: "10px", lineHeight: "14px", letterSpacing: "1px" },

  buttonPrimaryLarge: { fontFamily: Fonts.semiBold, fontSize: "16px", letterSpacing: "0.08px" },
  buttonPrimarySmall: { fontFamily: Fonts.semiBold, fontSize: "14px", letterSpacing: "0.07px" },
  buttonSecondary: { fontFamily: Fonts.medium, fontSize: "14px", letterSpacing: "0.04px" },
  buttonGhost: { fontFamily: Fonts.regular, fontSize: "16px" },

  inputText: { fontFamily: Fonts.medium, fontSize: "16px", lineHeight: "22px" },
};

// ---------------- Captions ----------------
export const captions = {
  welcomeTitle: {
    ...typography.h1,
    color: "#fff",
    textAlign: "left",
    marginBottom: "10px",
  },
  welcomeSubtitle: {
    ...typography.bodyMedium,
    color: "#ccc",
    marginTop: "8px",
    textAlign: "left",
  },
  sectionTitle: {
    ...typography.h3,
    color: "#111",
    textAlign: "left",
  },
  sectionSubtitle: {
    ...typography.bodySmall,
    color: "#777",
    textAlign: "justify",
  },
  dividerText: {
    ...typography.bodySmall,
    color: "#fff",
    textAlign: "center",
    margin: "0 8px",
  },
  buttonText: {
    ...typography.h6Bold,
    color: "#1e5e76",
    textAlign: "center",
    margin: "0 8px",
  },
};

// export const Fonts = {
//   // Poppins
//   regular: "Poppins-Regular",
//   medium: "Poppins-Medium",
//   semiBold: "Poppins-SemiBold",
//   bold: "Poppins-Bold",
//   extraBold: "Poppins-ExtraBold",
//   black: "Poppins-Black",

//   // Inter
//   interRegular: "Inter-Regular",
//   interMedium: "Inter-Medium",
//   interSemiBold: "Inter-SemiBold",
//   interBold: "Inter-Bold",
//   interExtraBold: "Inter-ExtraBold",
//   interBlack: "Inter-Black",

//   // Manrope
//   manropeRegular: "Manrope-Regular",
//   manropeMedium: "Manrope-Medium",
//   manropeSemiBold: "Manrope-SemiBold",
//   manropeBold: "Manrope-Bold",
//   manropeExtraBold: "Manrope-ExtraBold",
//   manropeBlack: "Manrope-Black",
// };

// // ---------------- Typography ----------------
// // Based on Style Guide 2 (Crea)
// export const typography = {
//   h1: { fontFamily: Fonts.extraBold, fontSize: 32, lineHeight: 40, letterSpacing: -0.16 },
//   h2: { fontFamily: Fonts.manropeBold, fontSize: 28, lineHeight: 35, letterSpacing: -0.07 },
//   h3: { fontFamily: Fonts.semiBold, fontSize: 24, lineHeight: 32 },
//   h4Bold: { fontFamily: Fonts.semiBold, fontSize: 20, lineHeight: 28 },
//   h4: { fontFamily: Fonts.medium, fontSize: 20, lineHeight: 28},
//   h5: { fontFamily: Fonts.medium, fontSize: 18, lineHeight: 24 },
//   h6Bold: { fontFamily: Fonts.semiBold, fontSize: 16, lineHeight: 22 },
//   h6: { fontFamily: Fonts.medium, fontSize: 16, lineHeight: 22 },

//   bodyLarge: { fontFamily: Fonts.interRegular, fontSize: 16, lineHeight: 24 },
//   bodyMedium: { fontFamily: Fonts.interRegular, fontSize: 14, lineHeight: 22 },
//   bodySmall: { fontFamily: Fonts.interRegular, fontSize: 12, lineHeight: 18, letterSpacing: 0.03 },

//   captionBold: { fontFamily: Fonts.interSemiBold, fontSize: 12, lineHeight: 18 },
//   overline: { fontFamily: Fonts.interRegular, fontSize: 10, lineHeight: 14, letterSpacing: 1 },

//   buttonPrimaryLarge: { fontFamily: Fonts.semiBold, fontSize: 16, letterSpacing: 0.08 },
//   buttonPrimarySmall: { fontFamily: Fonts.semiBold, fontSize: 14, letterSpacing: 0.07 },
//   buttonSecondary: { fontFamily: Fonts.medium, fontSize: 14, letterSpacing: 0.04 },
//   buttonGhost: { fontFamily: Fonts.regular, fontSize: 16 },

//   inputText: { fontFamily: Fonts.medium, fontSize: 16, lineHeight: 22 },
// };
// export const captions = {
//   welcomeTitle: {
//     ...typography.h1,
//     color: "#fff",
//     textAlign: "left",
//     alignSelf: "flex-start",
//     marginBottom: 10,
//   },
//   welcomeSubtitle: {
//     ...typography.bodyMedium,
//     color: "#ccc",
//     marginTop: 8,
//     textAlign: "left",
//     alignSelf: "flex-start",
//   },
//   sectionTitle: {
//     ...typography.h3,
//     color: "#111",
//     textAlign: "left",
//   },
//   sectionSubtitle: {
//     ...typography.bodySmall,
//     color: "#777",
//     textAlign: "justify",
//   },
//   dividerText: {
//     ...typography.bodySmall,
//     color: "#fff",
//     textAlign: "center",
//     marginHorizontal: 8,
//   },
//   buttonText: {
//     ...typography.h6Bold,
//     color: "#1e5e76",
//     textAlign: "center",
//     marginHorizontal: 8,
//   },
// };
export const convertHexToRGB = (hex) => {
    // check if it's a rgba
    if (hex.match('rgba')) {
      let triplet = hex.slice(5).split(',').slice(0, -1).join(',');
      return triplet;
    }
  
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
  
      return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
    }
  };



  export const getIPAndDeviceInfo = async () => {
  try {
    // Get public IP
    const ipResponse = await fetch("https://api.ipify.org?format=json");
    const { ip } = await ipResponse.json();

    // Get device info from browser
    const deviceName = `${navigator.platform} - ${navigator.userAgent}`;

    return {
      deviceIP: ip,
      deviceName,
    };
  } catch (error) {
    console.error("Failed to get IP/device info:", error);
    return {
      deviceIP: "",
      deviceName: navigator.userAgent, // fallback
    };
  }
};
export const getThemeByMode = (themeName, themeMode, themes) => {
  const darkKey = `${themeName}Dark`;
  return themeMode === "dark" && themes[darkKey]
    ? themes[darkKey]
    : themes[themeName];
};